<template>
  <div class="addOnlineContainer">
    <section>
      <h2>
        一、导入结算【骑手】
        <a @click="example">[ {{ downloadTxt }} ]</a>
      </h2>
      <div class="hint">
        <h3>注意事项</h3>
        <span>1、 必须为.xls或.xlsx结尾的excel；</span>
        <span>2、表格中不得有空行空列，无数据填0；</span>
        <span>3、表格中所有数据均为文本格式；</span>
        <span>4、表格中日期格式以-作为连接符(如2020-10)。</span>
      </div>
      <div>
        <label><i>*</i>结算月：</label>
        <a-month-picker @change="selectMonth" v-model="monthVal" />
      </div>
      <div>
        <label><i>*</i>结算表：</label>
        <input type="file" @change="excelData" :value="excelVal" />
      </div>
      <a-button type="primary" @click="submitUpload">{{ upTxt }}</a-button>
    </section>
    <section class="downloadStyle">
      <h2>二、下载结算【骑手】</h2>
      <div>
        <label>结算月：</label>
        <a-month-picker @change="downloadMonth" />
      </div>
      <div>
        <label>项目：</label>
        <a-select
          style="width: 300px"
          mode="multiple"
          showSearch
          :filterOption="filterOption"
          v-model="downloadProID"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </div>
      <a-button type="primary" @click="downloadExcel">{{
        downloadFollowTxt
      }}</a-button>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      attence: "",
      attenceFile: "",
      followFile: "",
      downloadTxt: "下载示例Excel",
      downloadFollowTxt: "下载",
      upFollowTxt: "上传",
      upTxt: "上传",
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 2 },
        wrapperCol: { span: 6 }
      },
      proList: [],
      proID: "",
      excelVal: "",
      downloadProID: [],
      month: "",
      month_date: "",
      monthVal: null
    };
  },
  mounted() {
    this.getPro(); //项目
  },
  methods: {
    selectMonth(date, dateString) {
      this.month_date = dateString;
      // console.log(dateString)
    },
    downloadMonth(date, dateString) {
      this.month = dateString;
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          trade_id: 5,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    excelData(e) {
      this.attence = e.target.files[0].name;
      this.attenceFile = e.target.files[0];
      // console.log(this.excelVal);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    example() {
      this.downloadTxt = "下载中...";
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Month_salary/downloadTpl?token=" +
        window.localStorage.getItem("xnwfPcToken");
      this.downloadTxt = "下载示例Excel";
    },
    submitUpload() {
      let _this = this;
      if (this.attenceFile != "" && this.month_date != "") {
        this.$confirm({
          title: "上传该项目结算信息，确认无误后进行操作?",
          okText: "确认",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            _this.upExcel();
          },
          onCancel() {
            // console.log("Cancel");
          },
          class: "test"
        });
      } else {
        this.$message.warning("标记*为必填项！");
      }
    },
    upExcel() {
      this.upTxt = "上传中...";
      let formData = new FormData();
      formData.append("excel", this.attenceFile);
      formData.append("token", window.localStorage.getItem("xnwfPcToken"));
      formData.append("month_date", this.month_date);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let url =
        this.httpsBasic.url + this.httpsBasic.people + "Month_salary/upload";
      axios
        .post(url, formData, config)
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.month_date = "";
            this.attenceFile = "";
            this.monthVal = null;
            this.$emit("hideInAdd", false);
          } else {
            this.$info({
              title: "提示",
              content: res.data.message,
              onOk() {}
            });
            // this.$message.warning();
          }
          this.upTxt = "上传";
        })
        .catch(err => {
          this.$message.error(err);
        });
      this.upTxt = "上传";
    },
    downloadExcel() {
      // console.log(this.month)
      this.downloadFollowTxt = "下载中...";
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.people +
        "Month_salary/downloadData?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&month=" +
        this.month +
        "&project_id=" +
        JSON.stringify(this.downloadProID);
      this.downloadFollowTxt = "下载";
    }
  }
};
</script>
<style lang="less" scoped>
.addOnlineContainer {
  padding: 30px 4%;
  > section {
    margin-bottom: 50px;
    > div {
      margin-top: 10px;
      i {
        font-size: 12px;
        color: #f56c6c;
        font-style: normal;
        display: inline-block;
        margin-right: 4px;
      }
    }
    h2 {
      margin-bottom: 10px;
      font-weight: normal;
      a {
        font-size: 14px;
        display: inline-block;
        margin-left: 20px;
      }
    }
    input {
      margin: 20px 30px;
    }
    button {
      display: block;
      margin-left: 70px;
    }
  }

  .downloadStyle {
    margin-top: 30px;
    button {
      margin-top: 20px;
    }
  }
  .hint {
    background: rgba(230, 162, 60, 0.1);
    padding: 10px 20px;
    margin: 10px 30px 20px;
    width: 400px;
    h3 {
      color: #666;
      font-size: 16px;
      font-weight: normal;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 24px;
      color: #666;
    }
  }
}
</style>
